import { NgModule } from '@angular/core';
import { PpmapComponent } from './ppmap/ppmap';
import { PbcatrulesComponent } from './pbcatrules/pbcatrules';
import { HistoryComponent } from './history/history';
import { AutomatedjobsComponent } from './automatedjobs/automatedjobs';
import { KontrollinfosComponent } from './kontrollinfos/kontrollinfos';
import { LPPBRecognizerComponent } from './lppbrecognizer/lppbrecognizer';
import { PbkategorielistitemComponent } from './pbkategorielistitem/pbkategorielistitem';
import { PbkundelistitemComponent } from './pbkundelistitem/pbkundelistitem';
import { PbcheckresultComponent } from './pbcheckresult/pbcheckresult';
import { AdditionalfieldsComponent } from './additionalfields/additionalfields';
import { AdditionalvaluesComponent } from './additionalvalues/additionalvalues';

import {IonicModule, IonicPageModule} from 'ionic-angular';
import { ImageCropperModule } from 'ngx-image-cropper';
import moment from 'moment';
import { PipesModule } from '../pipes/pipes.module';
import { MomentModule } from 'angular2-moment';
@NgModule({
	declarations: [PpmapComponent,
		PbcatrulesComponent
		,HistoryComponent
		,KontrollinfosComponent
		,LPPBRecognizerComponent
		, AutomatedjobsComponent
		, PbkategorielistitemComponent
		, PbkundelistitemComponent
		, PbcheckresultComponent
		, AdditionalfieldsComponent
		, AdditionalvaluesComponent
		
	],
	imports: [IonicModule
		, ImageCropperModule
		, PipesModule
		, MomentModule
	],
	exports: [
		PpmapComponent
		,PbcatrulesComponent
		,HistoryComponent
		,KontrollinfosComponent
		,LPPBRecognizerComponent
		, AutomatedjobsComponent
		, PbkategorielistitemComponent
		, PbkundelistitemComponent
		, PbcheckresultComponent
		, AdditionalfieldsComponent
		, AdditionalvaluesComponent

	]
})
export class ComponentsModule {}



// WEBPACK FOOTER //
// ./src/components/components.module.ts